import { Component, OnInit,Input } from '@angular/core';

@Component({
  selector: 'app-avgrating',
  templateUrl: './avgrating.component.html',
  styleUrls: ['./avgrating.component.sass']
})
export class AvgratingComponent implements OnInit {
  @Input('rate') rate: string;
  @Input('className') className: string;
  
  constructor() { }

  ngOnInit(): void {
  }

}
